(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sticker-slap reveals
  var els = document.querySelectorAll('[data-mynd-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // One-tap add by size
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mynd-add]');
    if (!chip || chip.disabled) return;
    e.preventDefault();
    var label = chip.textContent;
    chip.disabled = true;
    chip.classList.add('is-loading');
    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +chip.getAttribute('data-mynd-add'), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function (added) {
      chip.classList.remove('is-loading');
      chip.classList.add('is-added');
      chip.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('mynd:added', { detail: added }));
      if (window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') theme.ajaxCart.update();
      if (window.theme && theme.RightDrawer && typeof theme.RightDrawer.open === 'function') theme.RightDrawer.open();
      setTimeout(function () {
        chip.textContent = label;
        chip.classList.remove('is-added');
        chip.disabled = false;
      }, 1800);
    }).catch(function () {
      chip.classList.remove('is-loading');
      chip.textContent = 'Sold out';
    });
  });

  // Size sheet: one clean picker instead of a wall of size buttons on every card
  var sheet = null;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function closeSheet() { if (sheet) sheet.hidden = true; }
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'mqs-sheet';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="mqs-sheet__backdrop" data-sheet-close></div>' +
      '<div class="mqs-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="MqsSheetTitle">' +
      '<button type="button" class="mqs-sheet__close" data-sheet-close aria-label="Close">&times;</button>' +
      '<p class="mqs-sheet__title" id="MqsSheetTitle"></p><p class="mqs-sheet__price"></p>' +
      '<div class="mqs-sheet__body"></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    document.addEventListener('mynd:added', function () { setTimeout(closeSheet, 450); });
    return sheet;
  }
  function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }
  function openSheet(d) {
    ensureSheet();
    var opts = d.options || [];
    // Only options with a real choice count (a bundled chain has one value: skip it)
    var live = opts.map(function (o, i) { return i; }).filter(function (i) {
      return uniq(d.variants.map(function (v) { return v.o[i]; })).length > 1;
    });
    if (!live.length) live = [0];
    var sizeIdx = live[0];
    live.forEach(function (i) { if (/size|waist|length/i.test(opts[i]) && !/size|waist|length/i.test(opts[sizeIdx])) sizeIdx = i; });
    var otherIdx = live.length === 2 ? (live[0] === sizeIdx ? live[1] : live[0]) : -1;
    var flat = live.length > 2;
    var others = otherIdx >= 0 ? uniq(d.variants.map(function (v) { return v.o[otherIdx]; })) : [];
    var sel = others.filter(function (val) { return d.variants.some(function (v) { return v.o[otherIdx] === val && v.a; }); })[0] || others[0];
    sheet.querySelector('.mqs-sheet__title').textContent = d.title;
    var cents = +d.price || 0, dollars = (cents / 100).toFixed(2);
    sheet.querySelector('.mqs-sheet__price').textContent = '$' + (dollars.slice(-3) === '.00' ? dollars.slice(0, -3) : dollars);
    var body = sheet.querySelector('.mqs-sheet__body');
    function render() {
      var html = '';
      if (otherIdx >= 0) {
        html += '<p class="mqs-sheet__label">' + esc(opts[otherIdx]) + '</p><div class="mqs-sheet__pills">' +
          others.map(function (val) {
            var any = d.variants.some(function (v) { return v.o[otherIdx] === val && v.a; });
            return '<button type="button" class="mqs-sheet__pill' + (val === sel ? ' is-on' : '') + (any ? '' : ' is-out') + '" data-pill="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('') + '</div>';
      }
      var list = flat ? d.variants.map(function (v) { return { label: live.map(function (i) { return v.o[i]; }).join(' / '), v: v }; }) :
        uniq(d.variants.map(function (v) { return v.o[sizeIdx]; })).map(function (size) {
          var v = d.variants.filter(function (x) { return x.o[sizeIdx] === size && (otherIdx < 0 || x.o[otherIdx] === sel); })[0];
          return v ? { label: size, v: v } : null;
        }).filter(Boolean);
      html += '<p class="mqs-sheet__label">' + esc(flat ? 'Option' : (opts[sizeIdx] || 'Size')) + '</p><div class="mqs-sheet__grid' + (flat ? ' is-flat' : '') + '">' +
        list.map(function (it) {
          return it.v.a ? '<button type="button" class="mqs-sheet__size" data-mynd-add="' + it.v.id + '">' + esc(it.label) + '</button>' :
            '<button type="button" class="mqs-sheet__size is-out" disabled aria-label="' + esc(it.label) + ', sold out">' + esc(it.label) + '</button>';
        }).join('') + '</div>';
      if (list.some(function (it) { return !it.v.a; })) html += '<p class="mqs-sheet__legend"><span></span>Sold out</p>';
      body.innerHTML = html;
      body.querySelectorAll('[data-pill]').forEach(function (p) {
        p.addEventListener('click', function () { sel = p.getAttribute('data-pill'); render(); });
      });
    }
    render();
    sheet.hidden = false;
    var first = sheet.querySelector('.mqs-sheet__size:not([disabled])') || sheet.querySelector('.mqs-sheet__close');
    if (first) first.focus();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mqs-open]');
    if (!btn) return;
    e.preventDefault();
    var json = btn.parentNode.querySelector('[data-mqs-json]');
    if (!json) return;
    try { openSheet(JSON.parse(json.textContent)); } catch (err) {}
  });

  // Arrows for the sideways-scrolling rows (Shop the drop, Bundle up)
  document.querySelectorAll('.mqs__rail, .mbr__rail').forEach(function (rail) {
    var wrap = document.createElement('div');
    wrap.className = 'mrail';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);
    function mk(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mrail__btn mrail__btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Scroll back' : 'Scroll forward');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"/></svg>';
      b.addEventListener('click', function () {
        var card = rail.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
        if (rail.clientWidth > step * 1.8) step = Math.floor(rail.clientWidth / step) * step;
        rail.scrollBy({ left: dir === 'prev' ? -step : step, behavior: reduce ? 'auto' : 'smooth' });
      });
      wrap.appendChild(b);
      return b;
    }
    var prev = mk('prev'), next = mk('next');
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 4;
      prev.classList.toggle('is-off', rail.scrollLeft <= 4);
      next.classList.toggle('is-off', rail.scrollLeft >= max);
      wrap.classList.toggle('is-static', max <= 0);
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  });


  // ===== Size guide (compact): size chips + 4 key measurement tiles + baggy-fit diagram =====
  (function () {
    var tables = document.querySelectorAll('table.mynd-size');
    if (!tables.length) return;
    var UNIT_KEY = 'mynd:unit';
    function getUnit(def) { try { return localStorage.getItem(UNIT_KEY) || def; } catch (e) { return def; } }
    function setUnit(u) { try { localStorage.setItem(UNIT_KEY, u); } catch (e) {} }
    function keyOf(l) {
      l = l.toLowerCase();
      if (/fits waist/.test(l)) return 'fitwaist';
      if (/belt/.test(l)) return 'belt';
      if (/height/.test(l)) return 'height';
      if (/waist/.test(l)) return 'waist';
      if (/hip/.test(l)) return 'hip';
      if (/thigh/.test(l)) return 'thigh';
      if (/rise|crotch/.test(l)) return 'rise';
      if (/inseam|inner leg/.test(l)) return 'inseam';
      if (/opening/.test(l)) return 'opening';
      if (/chest/.test(l)) return 'chest';
      if (/shoulder/.test(l)) return 'shoulder';
      if (/sleeve/.test(l)) return 'sleeve';
      if (/body/.test(l)) return 'body';
      if (/length/.test(l)) return 'length';
      return 'other';
    }
    var SHORT = { waist: 'Waist', hip: 'Hip', thigh: 'Thigh', rise: 'Rise', inseam: 'Inseam', opening: 'Leg opening', length: 'Length',
      chest: 'Chest', body: 'Length', shoulder: 'Shoulder', sleeve: 'Sleeve', height: 'Fits height', belt: 'Belt', fitwaist: 'Fits waist' };
    var PRIORITY = { pants: ['waist', 'inseam', 'length', 'opening', 'rise', 'hip', 'thigh'], top: ['chest', 'body', 'shoulder', 'sleeve', 'height'] };
    function fmt(n) { return String(Math.round(n * 10) / 10).replace(/\.0$/, ''); }
    function feet(inches) { var f = Math.floor(inches / 12), i = Math.round(inches - f * 12); if (i === 12) { f++; i = 0; } return f + '\u2032' + i + '\u2033'; }
    function norm(s) { s = String(s).trim().toLowerCase(); return ({ small: 's', medium: 'm', large: 'l', 'extra large': 'xl', xxl: '2xl' })[s] || s; }

    // Baggy silhouettes: wide legs, dropped crotch, stacked hems; boxy tops with dropped shoulders
    var PANTS = { vb: '0 0 170 210',
      shape: '<path class="msg__garment" d="M42 12 H128 L154 186 Q146 193 136 189 Q126 194 116 189 Q104 194 92 188 L85 104 L78 188 Q66 194 54 189 Q44 194 34 189 Q24 193 16 186 Z"/>' +
        '<path class="msg__seam" d="M42 22 H128 M85 22 V70 M52 22 Q56 44 70 46 M118 22 Q114 44 100 46 M22 166 Q40 174 74 166 M96 166 Q130 174 148 166 M20 178 Q44 186 76 178 M94 178 Q126 186 150 178"/>',
      lines: { waist: [42, 5, 128, 5], hip: [37, 56, 133, 56], thigh: [27, 110, 81, 110], rise: [98, 12, 98, 104],
        inseam: [90, 110, 94, 184], opening: [16, 202, 78, 202], length: [162, 12, 162, 188] } };
    var JORTS = { vb: '0 0 170 160',
      shape: '<path class="msg__garment" d="M42 12 H128 L148 134 Q138 140 126 136 Q112 141 96 135 L86 100 L76 135 Q60 141 46 136 Q34 140 22 134 Z"/>' +
        '<path class="msg__seam" d="M42 22 H128 M85 22 V68 M52 22 Q56 44 70 46 M118 22 Q114 44 100 46 M26 126 Q48 132 74 126 M98 126 Q122 132 144 126"/>',
      lines: { waist: [42, 5, 128, 5], hip: [38, 56, 132, 56], rise: [98, 12, 98, 100], opening: [22, 150, 76, 150], length: [158, 12, 158, 136] } };
    var TOP = { vb: '0 0 230 190',
      shape: '<path class="msg__garment" d="M96 16 Q115 30 134 16 L172 22 L212 66 L186 92 L172 80 V178 H58 V80 L44 92 L18 66 L58 22 Z"/>' +
        '<path class="msg__seam" d="M58 22 V80 M172 22 V80 M58 170 H172"/>',
      lines: { chest: [58, 88, 172, 88], body: [115, 26, 115, 178], shoulder: [58, 8, 172, 8], sleeve: [178, 14, 218, 58] } };
    // Long-sleeve sweatshirt body (crewneck), and the hoodie version with a hood, pocket and drawstrings
    var LS_BODY = '<path class="msg__garment" d="M100 22 Q120 36 140 22 L180 30 L228 186 L203 195 L180 104 V204 H60 V104 L37 195 L12 186 L60 30 Z"/>';
    var LS_SEAMS = '<path class="msg__seam" d="M60 30 V104 M180 30 V104 M60 192 H180 M16 174 L38 166 M224 174 L202 166"/>';
    var LS_LINES = { chest: [60, 112, 180, 112], body: [120, 34, 120, 204], shoulder: [60, 36, 180, 36], sleeve: [188, 26, 236, 182] };
    var CREW = { vb: '0 0 240 214', lines: LS_LINES,
      shape: LS_BODY + LS_SEAMS + '<path class="msg__seam" d="M98 26 Q120 42 142 26"/>' };
    var HOOD = { vb: '0 -16 240 230', lines: LS_LINES,
      shape: '<path class="msg__garment" d="M90 28 Q82 -12 120 -14 Q158 -12 150 28 Z"/>' + LS_BODY + LS_SEAMS +
        '<path class="msg__seam" d="M102 26 Q120 2 138 26 M112 30 V62 M128 30 V62 M84 146 H156 L166 182 H74 Z"/>' };

    tables.forEach(function (table) {
      if (table.dataset.myndSizeInit === '1') return;
      table.dataset.myndSizeInit = '1';
      var cap = (table.querySelector('caption') || {}).textContent || '';
      var base = /centim/i.test(cap) ? 'cm' : /inch/i.test(cap) ? 'in' : 'none';
      var heads = Array.prototype.map.call(table.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
      var rows = Array.prototype.map.call(table.querySelectorAll('tbody tr'), function (tr) {
        return Array.prototype.map.call(tr.children, function (td) { return td.textContent.trim(); });
      }).filter(function (r) { return r.length === heads.length; });
      if (heads.length < 2 || !rows.length) return;
      var cols = heads.slice(1).map(function (h, i) { return { flat: /\(flat\)/i.test(h), key: keyOf(h), idx: i + 1 }; });
      var has = function (re) { return cols.some(function (c) { return re.test(c.key); }); };
      var type = has(/inseam|rise|opening|thigh/) ? 'pants' : has(/chest|shoulder|sleeve|body/) ? 'top' : 'plain';
      var h1 = document.querySelector('h1');
      var name = document.title + ' ' + (h1 ? h1.textContent : '');
      var art = type === 'pants' ? (/jort|short/i.test(name) ? JORTS : PANTS) : type === 'top' ? (/hood|zip/i.test(name) ? HOOD : (/crew|sweat/i.test(name) || has(/height/)) ? CREW : TOP) : null;
      if (type !== 'plain') {
        var order = PRIORITY[type];
        cols = cols.filter(function (c) { return order.indexOf(c.key) > -1; })
          .sort(function (a, b) { return order.indexOf(a.key) - order.indexOf(b.key); }).slice(0, 4);
      }
      var unit = base === 'none' ? 'none' : getUnit(base);
      var sizes = rows.map(function (r) { return r[0]; });
      var cur = Math.floor((sizes.length - 1) / 2);
      var active = cols[0] && cols[0].key;

      function val(row, c) {
        var raw = row[c.idx], n = parseFloat(raw);
        if (base === 'none' || isNaN(n) || !/^[\d.]+$/.test(raw)) return { v: raw, u: '' };
        var inch = base === 'in' ? n : n / 2.54, cm = base === 'cm' ? n : n * 2.54;
        if (c.key === 'height') return unit === 'in' ? { v: feet(inch), u: '' } : { v: fmt(cm), u: 'cm' };
        return unit === 'in' ? { v: fmt(inch), u: 'in' } : { v: fmt(cm), u: 'cm' };
      }

      var root = document.createElement('div');
      root.className = 'msg';
      table.parentNode.insertBefore(root, table);
      table.classList.add('msg__source');
      var heading = root.previousElementSibling;
      if (heading && /size chart/i.test(heading.textContent)) heading.hidden = true;
      var note = table.nextElementSibling;
      if (note && /\(flat\)|allow/i.test(note.textContent)) note.hidden = true;

      function render() {
        var row = rows[cur];
        var h = '<div class="msg__bar"><div class="msg__sizes" role="group" aria-label="Size">' + sizes.map(function (s, i) {
          return '<button type="button" data-i="' + i + '" aria-pressed="' + (i === cur) + '">' + s + '</button>';
        }).join('') + '</div>' + (base === 'none' ? '' :
          '<button type="button" class="msg__unit" data-unit aria-label="Switch units">' +
          '<span class="' + (unit === 'in' ? 'is-on' : '') + '">IN</span><span class="' + (unit === 'cm' ? 'is-on' : '') + '">CM</span></button>') + '</div>';
        h += '<div class="msg__body' + (art ? '' : ' msg__body--plain') + '">';
        if (art) {
          h += '<svg class="msg__art" viewBox="' + art.vb + '" aria-hidden="true">' + art.shape;
          cols.forEach(function (c) {
            var L = art.lines[c.key]; if (!L) return;
            h += '<g class="msg__ln' + (c.key === active ? ' is-on' : '') + '"><line x1="' + L[0] + '" y1="' + L[1] + '" x2="' + L[2] + '" y2="' + L[3] + '"/>' +
              '<circle cx="' + L[0] + '" cy="' + L[1] + '" r="3"/><circle cx="' + L[2] + '" cy="' + L[3] + '" r="3"/></g>';
          });
          h += '</svg>';
        }
        h += '<div class="msg__tiles">' + cols.map(function (c) {
          var v = val(row, c);
          return '<button type="button" class="msg__tile' + (c.key === active ? ' is-on' : '') + '" data-k="' + c.key + '">' +
            '<span class="msg__k">' + SHORT[c.key] + (c.flat ? ' <i>flat</i>' : '') + '</span>' +
            '<span class="msg__v">' + v.v + (v.u ? '<small>' + v.u + '</small>' : '') + '</span></button>';
        }).join('') + '</div></div>';
        if (cols.some(function (c) { return c.flat; })) h += '<p class="msg__note">Flat = laid flat, edge to edge. Double it for all the way around.</p>';
        root.innerHTML = h;
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        if (b.hasAttribute('data-unit')) { unit = unit === 'in' ? 'cm' : 'in'; setUnit(unit); }
        else if (b.dataset.i) cur = +b.dataset.i;
        else if (b.dataset.k) active = b.dataset.k;
        render();
      });
      root.addEventListener('mouseover', function (e) {
        var t = e.target.closest('.msg__tile'); if (!t || t.dataset.k === active) return;
        active = t.dataset.k; render();
      });
      document.addEventListener('change', function (e) {
        var t = e.target; if (!t || !t.closest || !t.closest('form[action*="/cart/add"], .product-form, [data-product-form]')) return;
        var vals = t.tagName === 'SELECT' ? ((t.options[t.selectedIndex] || {}).text || '').split(/\s*\/\s*/) : [t.value];
        for (var i = 0; i < sizes.length; i++) for (var j = 0; j < vals.length; j++)
          if (norm(vals[j]) === norm(sizes[i])) { cur = i; render(); return; }
      });
      render();
    });
  })();

  // Mobile "Shop the drop" bar hides once the shop rail is on screen or passed
  var bar = document.querySelector('[data-mynd-shopbar]');
  var target = document.getElementById('MyndQuickShop');
  if (bar && target && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      bar.classList.toggle('is-hidden', en.isIntersecting || en.boundingClientRect.top < 0);
    }).observe(target);
  } else if (bar) {
    bar.classList.add('is-hidden');
  }
})();
